import Dashboard from '@/demand/pages/Dashboard'
import Settings from '@/demand/pages/Settings'
import Activity from '@/reports/pages/Activity'
import BidderEndpoint from "@/demand/pages/BidderEndpoint"
import AdReview from '@/reports/pages/AdReview'
import Explorer from '@/reports/pages/Explorer/Explorer'
import ScanTabs from "./pages/ScanTabs"
import ThrottleStats from "./pages/ThrottleStats.vue";

export default [
  {
    path: '/demand/dashboard',
    name: 'DemandDashboard',
    component: Dashboard,
    meta: {
      title: 'Dashboard',
      breadcrumbs: [
        {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Demand', to: {name: 'DemandSettings', params: ['cid']}},
        {name: 'Dashboard'}
      ]
    }
  },
  {
    path: '/demand/:cid/settings',
    name: 'DemandSettings',
    component: Settings,
    props: true,
    meta:
      {
        title: 'Demand Settings',
        breadcrumbs:
          [
            {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
            {name: 'Demand', to: {name: 'DemandSettings', params: ['cid']}},
            {name: 'Settings'}
          ]
      }
  },
  {
    path: '/demand/:cid/activity',
    name: 'DemandActivity',
    component: Activity,
    props: true,
    meta:
      {
        title: 'Buying Activity',
        breadcrumbs: [
          {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
          {name: 'Demand', to: {name: 'DemandSettings', params: ['cid']}},
          {name: 'Reports'}
        ]
      }
  },
  {
    path: '/demand/:cid/endpoint/new',
    name: 'BidderEndpointNew',
    component: BidderEndpoint,
    props: true,
    meta:
      {
        permissions: ['TECHNICAL'],
        breadcrumbs:
          [
            {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
            {name: 'Bidder', to: {name: 'DemandSettings', params: ['cid']}},
            {name: 'New Endpoint'}
          ]
      }
  },
  {
    path: '/demand/:cid/endpoint/:eid',
    name: 'BidderEndpointSettings',
    component: BidderEndpoint,
    props: true,
    meta:
      {
        permissions: ['TECHNICAL'],
        breadcrumbs:
          [
            {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
            {name: 'Bidder', to: {name: 'DemandSettings', params: ['cid']}},
            {name: 'Edit Endpoint', to: {name: 'BidderEndpointSettings', params: ['cid', 'eid']}}
          ]
      }
  },
  {
    path: '/demand/:cid/adreview',
    name: 'DemandAdReview',
    component: AdReview,
    props: true,
    meta:
      {
        breadcrumbs:
          [
            {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
            {name: 'Bidder', to: {name: 'DemandSettings', params: ['cid']}},
            {name: 'Live Ad Review'}
          ]
      }
  },
  {
    path: '/demand/reports/explorer',
    name: 'DemandExplorer',
    component: Explorer,
    props: true,
    meta:
      {
        breadcrumbs:
          [
            {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
            {name: 'Bidder', to: {name: 'DemandSettings', params: ['cid']}},
            {name: 'Inventory Explorer'}
          ]
      }
  },
  {
    path: '/demand/:cid/scans',
    name: 'DemandScans',
    component: ScanTabs,
    props: true,
    meta: {
      title: 'Tag Scans',
      breadcrumbs: [
        {name: 'Profile', to: {name: 'CompanyProfile', params: ['cid']}},
        {name: 'Bidder', to: {name: 'DemandSettings', params: ['cid']}},
        {name: 'Bidder Tag Scans'}
      ]
    }
  }
]



// WEBPACK FOOTER //
// ./src/demand/routes.js